<template>
  <v-container>
    <template v-if="!categories.length && !loading">
      <div class="d-flex justify-center align-center">
        <strong>Немає категорій, додайте першу!</strong>
      </div>
    </template>
    <template v-else>
      <v-row>
        <v-col
          v-for="category of categories"
          :key="category.id"
          cols="4"
          md="2"
        >
          <v-card
            :color="category.color"
            class="rounded-xl pa-3"
            dark
            @click="openCategory(category)"
          >
            <v-responsive :aspect-ratio="1 / 1">
              <v-layout fill-height justify-center align-center>
                <span class="text-truncate font-weight-medium">{{
                  category.name
                }}</span>
              </v-layout>
            </v-responsive>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-if="loading">
      <div class="d-flex justify-center align-center mt-5">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "CategoriesList",
  props: {
    categories: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openCategory(category) {
      this.$emit("open-category", category);
    },
  },
};
</script>
